import api from 'utils/apiClient';

export const loadJJLikesStepRanges = (params) => {
  return api.get('/j_j_likes_counts', {
    params,
  })
}

export const createJJLikesStepRange = (data) => {
  return api.post('/j_j_likes_counts', data)
}

export const deleteJJLikesStepRange = (id) => {
  return api.delete(`/j_j_likes_counts/${id}`)
}

export const loadJJFortuneAvailabilitySettings = (params) => {
  return api.get('/fortune_availabilities', {
    params,
  })
}

export const editJJFortuneAvailabilitySettings = ({id, ...data}) => {
  return api.patch(`/fortune_availabilities/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json'
    }
  })
}

export const loadJJFortunePayouts = (params) => {
  return api.get('/payouts', {
    params,
  })
}

export const editJJFortunePayout = ({ id, ...data }) => {
  return api.patch(`/payouts/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json'
    }
  })
}

export const loadJoyJetIncome = (params) => {
  return api.get('/jjfortune-stats', {
    params,
  })
}

export const importJoyJetIncome = (params) => {
  return api.get('/jjfortune-stats.csv', {
    params,
    headers: {
      'Content-Type': 'text/csv',
    }
  })
}

export const addJJCoinsUser = ({ id, ...data }) => {
  return api.post(`/users/${id}/add_jjcoins`, data)
}